import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import CartaPorteCatalogoManager from '../../../../catalogs/managers/CartaPorteCatalogoManager';

class CartaPorteTiposFiguraPartesTransporteForm extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const ParteTransporte = CartaPorteCatalogoManager.get('c_cp_parte_transporte');

    let catalogos = {};

    catalogos.ParteTransporte = this.getCatalogo(ParteTransporte);

    this.setState({
        catalogos
      });
  }

  componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  rules(data) {
    return {
      'ParteTransporte': ['in:PT01,PT02,PT03,PT04,PT05,PT06,PT07,PT08,PT09,PT10,PT11,PT12'],
    }
  }

  getCatalogo = (values) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: item.descripcion,
          value: item.clave
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: 'ghost'
        }
      ].concat(sorted);
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, catalogos = {}, data = {} } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Parte Transporte"
              name="ParteTransporte"
              placeholder=""
              help=""
              minLength="16"
              maxLength="36"
              rules={ rules.ParteTransporte }
              value={ data.ParteTransporte }
              options={ catalogos.ParteTransporte }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias Partes Transporte usando el botón "Agregar partes transporte", la lista se mostrarán en la tabla de PartesTransporte.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar partes transporte
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteTiposFiguraPartesTransporteForm;